export default "__VITE_ASSET__DasCWOAe__"